"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const rsuite_1 = require("rsuite");
exports.Header = (props) => {
    const { searchQuery, title, components, handleItemCreate, handleSearch } = props;
    const [searchValue, setSearchValue] = react_1.useState(searchQuery && searchQuery.query || '');
    const submitSearch = () => handleSearch(searchValue);
    // Full overwrite
    if (components && components.Header) {
        return react_1.default.createElement(components.Header, Object.assign({}, props));
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(rsuite_1.FlexboxGrid, { align: "middle" },
            react_1.default.createElement(rsuite_1.FlexboxGrid.Item, { colspan: 12 },
                react_1.default.createElement("h3", null,
                    title,
                    react_1.default.createElement(rsuite_1.IconButton, { icon: react_1.default.createElement(rsuite_1.Icon, { icon: "plus" }), circle: true, size: "md", style: { marginLeft: 10 }, onClick: handleItemCreate }))),
            react_1.default.createElement(rsuite_1.FlexboxGrid.Item, { colspan: 12 },
                react_1.default.createElement(rsuite_1.InputGroup, { inside: true },
                    react_1.default.createElement(rsuite_1.Input, { placeholder: "Filter", value: searchValue, onChange: setSearchValue, onPressEnter: submitSearch }),
                    react_1.default.createElement(rsuite_1.InputGroup.Button, { onClick: submitSearch },
                        react_1.default.createElement(rsuite_1.Icon, { icon: "search" })))))));
};
//# sourceMappingURL=Header.js.map